import { validatorRules } from 'src/utilities/validator';

export enum PicInformationFieldName {
  FullName = 'full_name',
  BrandName = 'brand_name',
  Username = 'username',
  PhoneNumber = 'phone_number',
  Email = 'email',
  Password = 'password',
  ReferralCode = 'referral_code',
  CountryCode = 'country_code',
}

export const FORM_SCHEMA = {
  [PicInformationFieldName.FullName]: {
    initialValue: '',
    validationRule: validatorRules.full_name,
    customErrorMessages: {
      required: '',
    },
  },
  [PicInformationFieldName.BrandName]: {
    initialValue: '',
    validationRule: validatorRules.brand_name,
    customErrorMessages: {
      required: '',
      regex:
        'Brand name cannot use special characters (+, =, &, *, #, %, !, etc.).',
      not: "It's our placeholder brand name, please use other cool brand name for your business",
    },
  },
  [PicInformationFieldName.Username]: {
    initialValue: '',
    validationRule: validatorRules.username,
    customErrorMessages: {
      required: '',
      regex:
        'Username can only contain lowercase alphanumeric characters and first letter must be alphabet.',
    },
  },
  [PicInformationFieldName.PhoneNumber]: {
    initialValue: '',
    validationRule: ['required', validatorRules.phone_number[0]],
    customErrorMessages: {
      required: '',
    },
  },
  [PicInformationFieldName.Email]: {
    initialValue: '',
    validationRule: validatorRules.email,
    customErrorMessages: {
      required: '',
    },
  },
  [PicInformationFieldName.Password]: {
    initialValue: '',
    validationRule: validatorRules.password,
    customErrorMessages: {
      required: '',
    },
  },
  [PicInformationFieldName.ReferralCode]: {
    initialValue: '',
    validationRule: validatorRules.referral_code,
    customErrorMessages: {
      required: '',
    },
  },
  [PicInformationFieldName.CountryCode]: {
    initialValue: '+62',
    validationRule: validatorRules.country_code,
    customErrorMessages: {
      required: '',
    },
  },
};

export const LABEL = {
  alreadyHaveAccount: 'Already have an account?',
  backToLogin: 'Login',
  title: 'Create Account Now!',
};
